module.exports = __webpack_public_path__ + "media/content-creator/mobile-auto-1-69434ed8.png";